export function parsePktendStatisticsExtended(res) {
  const errorDroppedPktMatch = res.match(/ErrorDroppedPkt:\s*(\d+)/);

  if (!errorDroppedPktMatch) {
    return "unknown";
  }

  const errorDroppedPkt = parseInt(errorDroppedPktMatch[1]);
  const totalDnRxPkt = parseInt(res.match(/TotalDnRxPkt:\s*(\d+)/)[1]);
  const totalUpRxPkt = parseInt(res.match(/TotalUpRxPkt:\s*(\d+)/)[1]);
  if (isNaN(errorDroppedPkt) || totalDnRxPkt + totalUpRxPkt === 0) {
    return "unknown";
  }
  return `${((errorDroppedPkt / (totalDnRxPkt + totalUpRxPkt)) * 100).toFixed(
    2
  )}%`;
}

export function parseFilesystem(res) {
  let value;
  const lines = res.split("\n");
  let line;
  let attrs;
  if (lines.length > 2) {
    line = lines.find((line) => line[line.length - 1] == "/");
    if (line) {
      attrs = line.trim().split(/\s+/);
      value = attrs[2] + " used / " + attrs[3] + " available";
    }
  }
  if (value) return value;
  else return "unknown";
}

export function parseHardwareMemory(res) {
  const value = res.match(/Memory Size: (.*)/);
  if (value) return value[1];
  else return "unknown";
}

export const parseHostname = (res) => res.slice(0, -1);

export function parseHardwareChassis(res) {
  const values = [3];
  values[0] = res.match(/Vendor: (.*)/);
  if (values[0]) values[0] = values[0][1];
  else values[0] = "unknown";
  values[1] = res.match(/Product: (.*)/);
  if (values[1]) values[1] = values[1][1];
  else values[1] = "unknown";
  values[2] = res.match(/Serial: (.*)/);
  if (values[2]) values[2] = Number(values[2][1]) == 0 ? "n/a" : values[2][1];
  else values[2] = "unknown";
  return values;
}

export function parseHardwareCpu(res) {
  const value = [2];
  let aux;

  value[0] = res.match(/Model name:\s+(.*)/);
  if (value[0]) value[0] = value[0][1];
  else value[0] = "unknown";

  value[1] = res.match(/CPU\(s\):\s+(.*)/);
  aux = res.match(/Socket\(s\):\s+(.*)/);

  value[1] = value[1][1] + " (" + aux[1];
  aux = res.match(/Core\(s\) per socket:\s+(.*)/);
  value[1] += "x" + aux[1];
  aux = res.match(/Thread\(s\) per core:\s+(.*)/);
  value[1] += "x" + aux[1] + ")";
  if (!value[1]) value[1] = "unknown";

  return value;
}

const indent = line => '  ' + line;

const nestIntoNode = (bqnId, response) => [
  `BQN ID: ${bqnId}`,
  ...(response.split('\n').map(indent)),
  ].join('\n');

export const ensureAsNode = (response, bqnId = 0) =>
  response.trim().startsWith('BQN ID:') || bqnId === 'all'
    ? response
    : nestIntoNode(bqnId, response);
